module.exports = __webpack_public_path__ + "static/img/role-fr.4247500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/role-fr.png
// module id = 4pho
// module chunks = 1